"use client"

import { NoSsr } from '@mui/base/NoSsr';
import "@/app/style/globals.scss";
import Loading from './loading';

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <NoSsr fallback={<Loading />}>
      <><div id="ssoDiv"></div>{children}</>
    </NoSsr>
  );
}
